var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tablelist',{attrs:{"showCheckbox":false,"list":_vm.list,"columns":_vm.tableColumns}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"8px","color":"#999","font-size":".8em"}},[_c('div',[_vm._v("60分以下差，60-80分一般，80-90分良好，90-100分优秀。")])])
}]

export { render, staticRenderFns }